import { oadLX, getOadParams } from '@mtfe/pr-oad';
import { common, eventBus, container, dom } from '@mtfe/sweet-utils';
import { ActivityEntranceIcon, RulesPopup, RemindBox, GuideSearchModal, Toast } from '@mtfe/sweet-components';

import store from '../store';
import http from '../service';
import rules from '../components/Rules/dom.html';
import TrafficInitModal from '../components/TrafficInitModal/script';
import autoLogin from '../utils/autoLogin';
import { filterPoiInfoWithActivityInfoList } from '../utils/filter';
import TrafficCouponModal from '../components/TrafficCouponModal/script';
import { TRAFFIC_EXPERIMENT_KEY } from '../constants';
import TrafficToMiniModal from '../components/TrafficToMiniModal/script';
import { getWXAppHtml, getWxAuthorize } from '../utils';

const { storeCommon } = store;
const { isInWeixin, isMiniProgram } = container;
const PAGE_C_ID = 'c_waimai_kcgncd66';

const { qsParse } = common;
const queryInSearch = qsParse(window.location.search.slice(1));
const { hoaePageV } = queryInSearch;
const useLocFromMini = hoaePageV === '7.1';
/**
 * 鲜花实验
 * @param {object} data - 组件数据对象
 * @param {object} events - 组件事件对象
 */
export const experimentBanner = async (data, events) => {
    const { pageInfo = {} } = storeCommon.structInfo;
    // 实验逻辑
    try {
        const { pic: flowerBannerPicUrl, redirect: flowerBannerRedirectUrl, isShowRules = 'false' } = pageInfo.flower[0].data;
        if (flowerBannerPicUrl) {
            data.banner = `background-image:url(${flowerBannerPicUrl})`;
            if (flowerBannerRedirectUrl) {
                const rest = await getOadParams(useLocFromMini);
                const { pageSrc1, pageSrc2, pageSrc3, activityId } = rest.mediumParams;
                const { rootPvId } = rest;

                events.onClickBanner = () => {
                    /* eslint-disable no-template-curly-in-string */
                    window.location.href = flowerBannerRedirectUrl
                        .replace('${rootPvId}', rootPvId)
                        .replace('${pageSrc1}', pageSrc1)
                        .replace('${pageSrc2}', pageSrc2)
                        .replace('${pageSrc3}', pageSrc3)
                        .replace('${activityId}', activityId);
                    /* eslint-enable no-template-curly-in-string */
                };
                if (isShowRules === 'true') {
                    data.rulesStyle = 'display:flex';
                    events.openRuleDialog = () => {
                        RulesPopup({ content: rules });
                    };
                } else {
                    data.rulesStyle = 'display:none';
                }
            }
        }
    } catch (error) {
        console.warn('鲜花实验出错或未命中', error);
    }
};

/**
 * 高达活动入口实验
 * @param {*} data
 */
export const experimentGundamActivity = (data) => {
    const { expInfo = {} } = storeCommon.structInfo;
    const { gundamActivityUrl, activityEntranceBtnText = '签到有奖' } = expInfo;
    try {
        if (gundamActivityUrl) {
            data.activityEntranceIcon = ActivityEntranceIcon({
                btnText: activityEntranceBtnText,
                onClick: () => {
                    const cb = () => {
                        // 高达活动入口模块-按钮点击
                        oadLX.mc('b_waimai_v7p76vw8_mc');
                        setTimeout(() => {
                            window.location.href = gundamActivityUrl;
                        }, 10);
                    };
                    const autoLoginOptions = {
                        cb,
                        phone: storeCommon.phone,
                        loginSuccessCb: () => {
                            eventBus.$emit('loginSuccess', true);
                        },
                    };

                    autoLogin(autoLoginOptions);
                },
            });
            if (data.activityEntranceIcon) {
                // 高达活动入口模块-入口展示
                oadLX.mv('b_waimai_v7p76vw8_mv');
            }
        }
    } catch (error) {
        console.warn('高达入口展示实验出错或未命中', error);
    }
};

let isShowPopOnce = true;
/**
 * 用户在领取券以后，提示明日券膨胀
 * 实验下线，保留实验代码
 */
export const experimentRemindWillExpand = () => {
    const { phone, structInfo } = storeCommon;
    const { expInfo = {}, pageInfo = {} } = structInfo;
    try {
        if (phone) {
            const { popMsg, buttonMsg, popWinId, isShow } = pageInfo.userGrowthV1[0].data;
            const mcAction = () => http.frontMonitorPageLog(popWinId, expInfo, PAGE_C_ID, 'mc');
            const mvAction = () => http.frontMonitorPageLog(popWinId, expInfo, PAGE_C_ID, 'mv');
            if (isShow === 'true' && popWinId === 'tomorrowWillExpand' && isShowPopOnce) {
                RemindBox({
                    remindContent: popMsg,
                    remindBtnText: buttonMsg,
                    onBtnClick: () => {
                        mcAction();
                    },
                    oadLX,
                });
                mvAction();
                isShowPopOnce = false;
            }
        }
    } catch (error) {
        console.warn('用户成长体系实验，领取商家券弹出窗口未配置或出错', error);
    }
};
/**
 * 提示用户券已经膨胀，立即领券
 * 实验下线，保留实验代码
 */
export const experimentRemindExpanded = () => {
    const { phone, structInfo } = storeCommon;
    const { expInfo = {}, pageInfo = {} } = structInfo;
    try {
        if (phone) {
            const { popMsg, buttonMsg, popWinId, isShow } = pageInfo.userGrowthV1[0].data;

            const mcAction = () => http.frontMonitorPageLog(popWinId, expInfo, PAGE_C_ID, 'mc');
            const mvAction = () => http.frontMonitorPageLog(popWinId, expInfo, PAGE_C_ID, 'mv');

            if (isShow === 'true' && popWinId === 'couponExpanded' && isShowPopOnce) {
                RemindBox({
                    remindContent: popMsg,
                    remindBtnText: buttonMsg,
                    onBtnClick: () => {
                        mcAction();
                    },
                    oadLX,
                });
                mvAction();
                isShowPopOnce = false;
            }
        }
    } catch (error) {
        console.warn('用户提示实验出错或未命中', error);
    }
};

/**
 *  判断是否显示优惠券列表和订单返现，并根据实验信息决定优先展示哪个。
 * @returns {Object} 返回一个对象，包含是否优先展示，以及红包福利和返现福利的索引。如果满足显示外卖疯狂优惠券列表和外卖订单返现的条件，根据实验信息决定优先展示哪个；如果不满足条件，抛出错误。
 * @throws {Error} 当不满足实验条件时，会抛出错误
 * @example
 * const result = experimentIsShowCouponListPriority();
 * console.log(result); // 输出：{ isShowFirst: true, redBagWelfareIndex: '福利2', cashBackWelfareIndex: '福利1' }
 * @author 美团语音交互部
 */
export const experimentIsShowCouponListPriority = () => {
    const { struct, expInfo } = storeCommon.structInfo;
    const { dom_wm_red_bag: domWmRedBag, dom_wm_every_day_coupon: domWmEveryDayCoupon, dom_wm_self_promotion_order: domWmSelfPromotionOrder } = struct;

    try {
        const storeWmRedBag = store[domWmRedBag.recallBizId];
        const storeWmEveryDayCoupon = store[domWmEveryDayCoupon.recallBizId];
        const storeWmOrderCashBack = store[domWmSelfPromotionOrder.recallBizId];
        const { isShowCouponListPriority = '' } = expInfo;

        const couponListFirst = {
            isShowCouponListFirst: true,
            couponListWelfareIndex: '福利1',
            cashBackWelfareIndex: '福利2',
            domId: 'storeWmOrderCashBack-second',
        };
        const cashBackFirst = {
            isShowCouponListFirst: false,
            couponListWelfareIndex: '福利2',
            cashBackWelfareIndex: '福利1',
            domId: 'storeWmOrderCashBack-first',
        };
        const cashBackDefault = {
            isShowCouponListFirst: true,
            couponListWelfareIndex: '福利',
            cashBackWelfareIndex: '福利',
        };

        const couponList = [];
        if (storeWmRedBag.isShow) {
            couponList.push(...storeWmRedBag.discountData.redBagList);
        }
        if (storeWmEveryDayCoupon.isShow) {
            couponList.push(...storeWmEveryDayCoupon.discountData.couponList);
        }
        const isShowWaimaiCrazyCouponList = couponList.length > 0 && (storeWmRedBag.isShow || storeWmEveryDayCoupon.isShow);
        const isShowWaimaiOrderCashBack = storeWmOrderCashBack.isShow;

        if (isShowWaimaiCrazyCouponList && isShowWaimaiOrderCashBack) {
            if (isShowCouponListPriority === 'true') {
                const res = couponListFirst;
                http.frontMonitorPageLog(res.domId, expInfo, '', 'mv');
                return res;
            } else {
                const res = cashBackFirst;
                http.frontMonitorPageLog(res.domId, expInfo, '', 'mv');
                return res;
            }
        } else {
            console.warn('优先展示实验：未达到实验条件');
            return cashBackDefault;
        }
    } catch (error) {
        console.warn('优先展示实验出错', error);
    }
};

export const experimentGuideSearch = (data) => {
    try {
        const { expInfo = {} } = storeCommon.structInfo;
        const { isShowGuideSearch } = expInfo;
        if (isShowGuideSearch === 'true') {
            data.activityEntranceIcon = ActivityEntranceIcon({
                btnText: '试吃返现',
                onClick: () => {
                    GuideSearchModal();
                },
            });
        }
    } catch (error) {
        console.warn('引导至站内搜索实验出错或未命中', error);
    }
};

/**
 * 实验已经推全，这个弹窗不再展示，此处保留实验代码
 * 初始化引流实验
 * 该函数用于根据实验信息和订单返现数据，决定是否展示引流模态框。
 * 如果满足以下条件，则展示引流模态框：
 * 1. 实验信息中的bigCoupon为true。
 * 2. 实验信息中的trafficPopupExperiment为allTraffic或initTraffic。
 * 3. 存在订单返现数据，且订单返现数据中的poiList为数组且长度大于0。
 * 如果不满足上述条件，则不展示引流模态框。
 * @throws {Error} 如果引流配置未配置或出错，会捕获错误并在控制台输出警告信息。
 */
export const experimentTrafficInit = () => {
    try {
        const { expInfo = {} } = storeCommon.structInfo;
        const { trafficPopupExperiment = '', bigCoupon = '' } = expInfo;
        const { dom_wm_self_promotion_order: domWmSelfPromotionOrder } = storeCommon.structInfo.struct;
        const storeOrderCashBack = store[domWmSelfPromotionOrder.recallBizId];
        if (
            bigCoupon === 'true' &&
            (trafficPopupExperiment === TRAFFIC_EXPERIMENT_KEY.allTraffic || trafficPopupExperiment === TRAFFIC_EXPERIMENT_KEY.initTraffic) &&
            storeOrderCashBack &&
            storeOrderCashBack.poiData &&
            Array.isArray(storeOrderCashBack.poiData.poiList) &&
            filterPoiInfoWithActivityInfoList(storeOrderCashBack.poiData.poiList).length > 0
        ) {
            TrafficInitModal({ activityId: trafficPopupExperiment });
        }
    } catch (error) {
        console.warn('引流配置未配置或者出错', error);
    }
};

/**
 * 引流优惠券实验
 * 该函数用于根据实验信息和订单返现数据，决定是否展示引流优惠券模态框。
 * 如果满足以下条件，则展示引流优惠券模态框：
 * 1. 实验信息中的bigCoupon为true。
 * 2. 实验信息中的trafficPopupExperiment为allTraffic或couponTraffic。
 * 3. 存在订单返现数据，且订单返现数据中的poiList为数组且长度大于0。
 * 如果不满足上述条件，则显示领取成功的提示信息。
 * @throws {Error} 如果引流配置未配置或出错，会捕获错误并在控制台输出警告信息。
 */

export const experimentTrafficCoupon = () => {
    try {
        const { expInfo = {} } = storeCommon.structInfo;
        const { trafficPopupExperiment = '', bigCoupon = '' } = expInfo;
        const { dom_wm_self_promotion_order: domWmSelfPromotionOrder } = storeCommon.structInfo.struct;
        const storeOrderCashBack = store[domWmSelfPromotionOrder.recallBizId];
        if (
            bigCoupon === 'true' &&
            (trafficPopupExperiment === TRAFFIC_EXPERIMENT_KEY.allTraffic || trafficPopupExperiment === TRAFFIC_EXPERIMENT_KEY.couponTraffic) &&
            storeOrderCashBack &&
            storeOrderCashBack.poiData &&
            Array.isArray(storeOrderCashBack.poiData.poiList) &&
            filterPoiInfoWithActivityInfoList(storeOrderCashBack.poiData.poiList).length > 0
        ) {
            TrafficCouponModal({ activityId: trafficPopupExperiment });
        } else {
            Toast({ message: '领取成功', position: 'bottom' });
        }
    } catch (error) {
        console.warn('引流配置未配置或者出错', error);
    }
};

/**
 * 引流文本实验
 * 该函数用于根据实验信息和订单返现数据，决定是否进行引流文本实验。
 * 如果满足以下条件，则进行引流文本实验：
 * 1. 实验信息中的bigCoupon为true。
 * 2. 实验信息中的trafficToWxMiniProgram为true。
 * 3. 存在订单返现数据，且订单返现数据中的poiList为数组且长度大于0。
 * 如果不满足上述条件，则不进行引流文本实验。
 * @returns {boolean} 是否进行引流文本实验。
 * @throws {Error} 如果引流配置未配置或出错，会捕获错误并在控制台输出警告信息。
 */
export const experimentTrafficMiniProgramText = () => {
    try {
        const { expInfo = {} } = storeCommon.structInfo;
        const { trafficToWxMiniProgram = '', bigCoupon = '' } = expInfo;
        const { dom_wm_self_promotion_order: domWmSelfPromotionOrder } = storeCommon.structInfo.struct;
        const storeOrderCashBack = store[domWmSelfPromotionOrder.recallBizId];

        if (
            bigCoupon === 'true' &&
            trafficToWxMiniProgram === 'true' &&
            storeOrderCashBack &&
            storeOrderCashBack.poiData &&
            Array.isArray(storeOrderCashBack.poiData.poiList) &&
            filterPoiInfoWithActivityInfoList(storeOrderCashBack.poiData.poiList).length > 0
        ) {
            // 进行实验
            return true;
        }
        return false;
    } catch (error) {
        console.warn('引流配置未配置或者出错', error);
    }
};

/**
 * 引流至微信小程序实验
 * 该函数用于根据实验信息，决定是否进行引流至微信小程序的实验。
 * 如果满足以下条件，则进行引流至微信小程序的实验：
 * 1. 实验信息中的bigCoupon为true。
 * 2. 实验信息中的trafficToWxMiniProgram为true。
 * 如果不满足上述条件，则显示领取成功的提示信息。
 * @throws {Error} 如果引流配置未配置或出错，会捕获错误并在控制台输出警告信息。
 */
export const experimentTrafficMiniProgramModal = () => {
    try {
        const { expInfo = {} } = storeCommon.structInfo;
        const { trafficToWxMiniProgram = '', bigCoupon = '' } = expInfo;

        if (bigCoupon === 'true' && trafficToWxMiniProgram === 'true') {
            if (isInWeixin && !isMiniProgram) {
                getWxAuthorize(() => {
                    TrafficToMiniModal(getWXAppHtml(96));
                });
            } else {
                TrafficToMiniModal();
            }
        } else {
            Toast({ message: '领取成功', position: 'bottom' });
        }
    } catch (error) {
        console.warn('引流配置未配置或者出错', error);
    }
};

export const experimentTrafficMiniProgramButton = (btnId, height, textBtnId = '') => {
    try {
        const { expInfo = {} } = storeCommon.structInfo;
        const { trafficToWxMiniProgram = '', bigCoupon = '' } = expInfo;
        if (bigCoupon === 'true' && trafficToWxMiniProgram === 'true' && window.wx && isInWeixin && !isMiniProgram) {
            // eslint-disable-next-line
            // console.log('OrderCashBackReady: => ready 执行', wx);
            getWxAuthorize(() => {
                if (btnId) {
                    const btnContainer = dom.$id(btnId);
                    if (btnContainer) {
                        btnContainer.innerHTML = getWXAppHtml(height);
                    }
                }

                if (textBtnId) {
                    const btnTextContainer = dom.$id(textBtnId);
                    if (btnTextContainer) {
                        btnTextContainer.innerText = '去试吃官查看活动详情';
                    }
                }
            });
        }
    } catch (error) {
        console.warn('引流配置未配置或者出错', error);
    }
};
